const DATE_FORMATS = {
  'YYYY/MM/DD': ['ar', 'ja', 'ko', 'th', 'zh'],
  'YYYY/DD/MM': ['ar-us', 'zh-us'],
  'DD/MM/YYYY': ['de', 'en', 'es', 'fr', 'id', 'it', 'nl', 'pl', 'pt', 'pt-br', 'ru', 'tr'],
  'MM/DD/YYYY': ['en-us', 'es-us']
};

export const SERVER_FORMAT = 'YYYY-MM-DD';
export const API_V2_FORMAT = 'DD/MM/YYYY';

export const getCookie = (name) => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

export const getDateFormat = (
  urlLang,
  userLocalization = getCookie('userLocalization')
) => {
  const findFormat = (locale) => {
    for (const format in DATE_FORMATS) {
      if (DATE_FORMATS[format].includes(locale)) {
        return format;
      }
    }
    return null;
  };

  const combo = urlLang + '-' + userLocalization;
  return findFormat(combo) || findFormat(urlLang) || 'DD/MM/YYYY';
};

export const padZero = (val) => {
  const c = '0';
  const len = 2;
  val = String(val);
  while (val.length < len) val = c + val;
  return val;
};

export const toLocaleFormat = (
  date,
  lang,
  userLocalization
) => {
  const currentDate = new Date(date);
  if (isNaN(currentDate.getTime())) return null;
  return getDateFormat(lang, userLocalization)
    .replace('YYYY', currentDate.getFullYear())
    .replace('MM', padZero(parseInt(currentDate.getMonth()+ 1)))
    .replace('DD', padZero(parseInt(currentDate.getDate())));
};
